import { useCallback, useEffect, useState } from "react"
import { useAuth } from "@clerk/clerk-react"
import { getTenantMe, type TenantMeResponse } from "../api/onboarding"

export function useTenantOnboarding() {
  const { getToken, isLoaded, isSignedIn } = useAuth()
  const [tenant, setTenant] = useState<TenantMeResponse | null>(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<Error | null>(null)

  const fetchTenant = useCallback(async () => {
    if (!isLoaded || !isSignedIn) return
    setLoading(true)
    try {
      const token = await getToken()
      if (!token) throw new Error("No auth token")
      const data = await getTenantMe(token)
      setTenant(data)
      setError(null)
    } catch (err) {
      setError(err as Error)
    } finally {
      setLoading(false)
    }
  }, [getToken, isLoaded, isSignedIn])

  useEffect(() => {
    fetchTenant()
  }, [fetchTenant])

  return { tenant, loading, error, refetch: fetchTenant }
}
